import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'

export const notificationWarningsSelector = createSelector(
  pageSelectors.notification,
  (notification?: WpsRuntime.atv.wps.NotificationFragmentModelProps) => notification && notification.warnings
)
